import { Notification } from "lib/components/Notification";
import * as React from "react";
import { LEVEL_ERROR, LEVEL_SUCCESS, notificationStore } from "lib/store";
import { runInAction } from "mobx";
import { useEffect } from "react";
import { registerComponent } from "lib/components";

interface NotificationAppProps {
  message: string;
  level: string;
  title: string;
}

const NotificationApp = (props: NotificationAppProps) => {
  const { message, level, title } = props;
  useEffect(() => {
    runInAction(() => {
      switch (level) {
        case LEVEL_SUCCESS:
          notificationStore.notifySuccess(message, title);
          break;
        case LEVEL_ERROR:
          notificationStore.notifyError(message, title);
          break;
      }
    });
  }, []);
  return <Notification />;
};

registerComponent({ NotificationApp });
